var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',[_c('PageHeader',{attrs:{"title":_vm.title,"items":_vm.items}}),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('h4',{staticClass:"card-title mb-4"},[_vm._v("All Vaults")]),_c('div',{staticClass:"form-body"},[_c('AllVaultsTable')],1)])])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }